import React, { Component } from 'react';
import { connect } from 'dva';
import { Button, message } from 'antd';
import AddLabelModal from './Components/AddLabelModal/index';
import Container from '../../../../../components/Container';
import ListPage from '../../../../../components/ListPage';
import TableList from './Components/ListTable';
import GroupTree from './Components/GroupTree';
import Order from './Components/Order';
import styles from './index.less';

@connect(({ labelSetting, user }) => {
  return {
    currentUser: user.currentUser,
    ...labelSetting,
  };
})
class LabelSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      currentGroupData: {},
    };
  }

  componentDidMount() {
    const { params } = this.props;
    this.getAllGroupList();
    this.fetchGroupList(params);
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'labelSetting/reset',
    });
  }

  getAllGroupList = () => {
    const { params, dispatch } = this.props;
    const { appCode } = params;
    dispatch({
      type: 'labelSetting/fetchAllGroupList',
      params: {
        appCode,
      },
    });
  };

  onGroupTreeChange = selectedKeys => {
    const { params, dispatch, allGroupList } = this.props;
    const data = allGroupList.filter(item => item.id == selectedKeys[0]);
    const tempParams = {
      ...params,
      page: 1,
    };
    dispatch({
      type: 'labelSetting/saveState',
      payload: {
        isGroup: selectedKeys[0] === 'group',
        currentTagData: data[0],
        params: tempParams,
      },
    });

    this.setState(
      {
        currentGroupData: data[0],
      },
      () => {
        if (selectedKeys[0] === 'group') {
          this.fetchGroupList(tempParams);
        } else {
          this.fetchLabelList(tempParams);
        }
      }
    );
  };

  fetchLabelList = params => {
    const { dispatch } = this.props;
    const { currentGroupData } = this.state;
    params.groupId = currentGroupData.id;
    this.setState({ loading: true });
    dispatch({
      type: 'labelSetting/fetchLabelList',
      params,
    })
      .then(() => {
        this.setState({
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchGroupList = params => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'labelSetting/fetchGroupList',
      params,
    })
      .then(() => {
        this.setState({
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  deleteLabel = record => {
    const { dispatch, params } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'labelSetting/fetchLabelDelete',
      params: { id: record.id, appCode: params.appCode },
    })
      .then(() => {
        this.setState({ loading: false });
        message.success('删除成功');
        this.fetchLabelList(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  deleteGroup = record => {
    const { dispatch, params } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'labelSetting/fetchGroupDelete',
      params: { id: record.id, appCode: params.appCode },
    })
      .then(() => {
        this.setState({ loading: false });
        message.success('删除成功');
        this.fetchGroupList(params);
        this.getAllGroupList();
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  orderSwitch = (record, flag) => {
    const { dispatch, params } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'labelSetting/fetchOrderSwitch',
      params: { id: record.id, appCode: params.appCode, flag },
    })
      .then(() => {
        this.setState({ loading: false });
        message.success(`批量${flag === 'on' ? '启用' : '禁用'}成功`);
        this.fetchGroupList(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  orderMove = (record, flag) => {
    const { dispatch, params, isGroup } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'labelSetting/fetchGroupMove',
      params: { id: record.id, appCode: params.appCode, flag },
      currentType: isGroup ? 'group' : 'label',
    })
      .then(() => {
        this.setState({ loading: false });
        message.success('修改成功');
        if (isGroup) {
          this.fetchGroupList(params);
          this.getAllGroupList();
        } else {
          this.fetchLabelList(params);
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchSubmit = record => {
    const { dispatch, params } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'labelSetting/fetchUpAndDownLabel',
      params: { id: record.id, appCode: params.appCode, upAndDown: record.status === 0 ? 1 : 0 },
    })
      .then(() => {
        this.setState({ loading: false });
        message.success(`${record.status === 0 ? '禁用' : '启用'}成功`);
        this.fetchLabelList(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchAddAndModifyLabel = values => {
    const { dispatch, params } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'labelSetting/fetchAddAndModifyLabel',
      params: { ...values, appCode: params.appCode },
    })
      .then(() => {
        this.setState({
          loading: false,
        });
        dispatch({
          type: 'labelSetting/saveState',
          payload: { modalVisible: false, formData: {} },
        });
        message.success(`${values.id ? '修改' : '添加'}成功`);
        this.fetchLabelList(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchAddAndModifyGroup = values => {
    const { dispatch, params } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'labelSetting/fetchAddAndModifyGroup',
      params: { ...values, appCode: params.appCode },
    })
      .then(() => {
        this.setState({
          loading: false,
        });
        dispatch({
          type: 'labelSetting/saveState',
          payload: { modalVisible: false, formData: {} },
        });
        message.success(`${values.id === 0 ? '添加' : '修改'}成功`);
        this.fetchGroupList(params);
        this.getAllGroupList();
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  changeOrderVisible = status => {
    const { dispatch } = this.props;
    dispatch({
      type: 'labelSetting/saveState',
      payload: { showOrderModal: status },
    });
  };

  addGroup = () => {
    const { dispatch, isGroup } = this.props;
    dispatch({
      type: 'labelSetting/saveState',
      payload: { modalTitle: isGroup ? '新增分组' : '新增标签', modalVisible: true },
    });
  };

  renserButton = () => {
    const { isGroup } = this.props;
    const { currentGroupData = {} } = this.state;
    const { groupType = '' } = currentGroupData;
    return (
      <>
        {(groupType !== '系统' || isGroup) && (
          <Button type="primary" onClick={this.addGroup}>
            + {isGroup ? '新增分组' : '新增标签'}
          </Button>
        )}
        <Button onClick={() => this.changeOrderVisible(true)}>调整顺序</Button>
      </>
    );
  };

  pageChange = params => {
    const { isGroup } = this.props;
    if (isGroup) {
      this.fetchGroupList(params);
    } else {
      this.fetchLabelList(params);
    }
  };

  render() {
    const { loading } = this.state;
    const { currentTagData } = this.props;

    const pageProps = {
      spinProps: { spinning: loading },
      className: styles.root,
    };

    return (
      <Container breStates={!0} version={2} defaultPadding>
        <ListPage {...pageProps}>
          <div className="content">
            <div className="left">
              <GroupTree onGroupTreeChange={this.onGroupTreeChange} />
            </div>
            <div className="right">
              <section className="create-button">{this.renserButton()}</section>
              <section className="table-area">
                <TableList
                  fetchSubmit={this.fetchSubmit}
                  deleteLabel={this.deleteLabel}
                  deleteGroup={this.deleteGroup}
                  orderSwitch={this.orderSwitch}
                  pageChange={this.pageChange}
                />
              </section>
            </div>
          </div>
          <AddLabelModal
            fetchAddAndModifyLabel={this.fetchAddAndModifyLabel}
            fetchAddAndModifyGroup={this.fetchAddAndModifyGroup}
          />
          <Order changeOrderVisible={this.changeOrderVisible} orderMove={this.orderMove} />
        </ListPage>
      </Container>
    );
  }
}

export default LabelSetting;
